let Utils = require("../lib/Utils");
let TimeZone = require("../lib/TimeZone");
let Format = require("../lib/Format");

let Page = function (props) {
  let { years, months, tz, data, selectedTs, onSelect, width } = props;
  let blocks = [];
  let daysInMonth = new Date(years, months + 1, 0).getDate();
  let d = 1 - new Date(years, months, 1).getDay();
  let w = width;
  let x = -w;
  let y = -w;
  let tsMap = Utils.hash(data, "ts");
  let gmtTs;
  let match = undefined;

  for (let i = 0; i < 42; i++) {
    x += w;

    if (i % 7 === 0) {
      x = 0;
      y += w;
    }

    gmtTs = TimeZone.info({ years, months, date: d }, "GMT", "DAY_START").value;
    match = tsMap[gmtTs];

    blocks.push(
      <g
        key={i}
        transform={"translate(" + x + "," + y + ")"}
        data-day={d >= 1 && d <= daysInMonth ? d : null}
        data-ts={match ? match.ts : null}
        data-selected={gmtTs === selectedTs}>
        <rect
          width={w}
          height={w}
          rx="2"
          ry="2"
          data-tooltip={match ? Format.date(match.ts, "GMT", "long") : null}
          onClick={match ? onSelect.bind(null, match.ts, match.ref) : null}/>
          {match ? (
            <circle cx={w / 2} cy={w / 2} r={Math.max(2, (w / 2.5) * Math.sqrt(match.value))}/>
          ) : null}
      </g>
    );

    d++;
  }

  return (
    <div className="mc-calendar-page">
      <div>{Format.date(new Date(years, months, 2), tz, "cal")}</div>
      <div>
        {"SMTWTFS".split("").map(function (s, i) {
          return <span key={i}>{s}</span>;
        })}
      </div>
      <svg width={w * 7} height={w * 6}>
        {blocks}
      </svg>
    </div>
  );
};

let Calendar = function (props) {
  let { ts, tz, data, onSelect, pages, width = 175 } = props;

  let now = Date.now();
  let n = data.length;
  let a = mc.tz.info(n ? data[0].ts : now, "GMT");
  let b = mc.tz.info(n ? data[n - 1].ts : now, "GMT");
  let p = Math.max(pages || 1, 1 + ((12 * b.years) + b.months) - ((12 * a.years) + a.months));

  let pgs = new Array(p).fill(0).map(function (p, i) {
    return (
      <Page
        key={i}
        years={a.years + Math.floor((a.months + i) / 12)}
        months={(a.months + i) % 12}
        data={data}
        tz={tz}
        width={Math.floor(width / 7)}
        selectedTs={ts}
        onSelect={onSelect}/>
    );
  });

  return (
    <div className="mc-calendar">
      {pgs}
    </div>
  );
};

module.exports = Calendar;